import { Tag } from "./Tag";
import './CustomTag.css';

const tagTypes = {
  part: {icon: 'icon-part', label: 'Serialized Parts'},
  consumable: {icon: 'icon-consumable', label: 'Consumables'}
}


export const CustomTag = ({tag}) => {
  return (
    <span className={`custom-tag-component ${tag}`}>
      <Tag icon={tagTypes[tag]?.icon ?? ''} tag={tagTypes[tag]?.label ?? tag}></Tag>
    </span>
  );
}